import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Button,
    Card,
    Typography,
    Layout,
    Row,
    Col,
    Checkbox,
} from "antd";
import {
    UserOutlined,
    LockOutlined,
    SafetyCertificateOutlined,
} from "@ant-design/icons";
import styles from "./index.css";
import LoginForm from "./components/LoginForm";

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

const LoginPage = () => {
    const courseUrl = "https://fdddy.com";
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // 获取 URL 参数 s 的值
        const urlParams = new URLSearchParams(window.location.search);
        const sParam = urlParams.get("s");

        if (Number(sParam) === 2) {
            window.location.href = courseUrl;
        }
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        // console.log("Login values:", values);
        // 这里添加登录逻辑
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    };

    return (
        <div className={styles.welcome}>
            <div flex="cross:center" className={styles.loginHeader}>
                <img
                    alt=""
                    src={require("@/assets/yz_logo.png")}
                    style={{
                        height: "45px",
                        marginRight: "10px",
                    }}
                />
                {/* <img
                    alt=""
                    src={require("@/assets/xiaozhi-ai.png")}
                    style={{ width: "auto", height: "18px" }}
                /> */}
            </div>
            <div className={styles.loginPerson}>
                <img src={require("@/assets/login/login-person.png")} />
            </div>
            <div className={styles.loginBox}>
                <div
                    flex="cross:center"
                    style={{ gap: 20 }}
                    className={styles.loginBoxTop}
                >
                    <img
                        src={require("@/assets/login/hi.png")}
                        style={{ width: "34px", height: "34px" }}
                    />
                    <div className={styles.loginText}>登录</div>
                    <div className={styles.loginWelcome}>WELCOME TO LOGIN</div>
                </div>
                <LoginForm />
            </div>
        </div>
    );
};

export default LoginPage;
